import { render } from "./RegisterSection.vue?vue&type=template&id=6e45e9ee"
import script from "./RegisterSection.vue?vue&type=script&lang=js"
export * from "./RegisterSection.vue?vue&type=script&lang=js"

import "./RegisterSection.vue?vue&type=style&index=0&id=6e45e9ee&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__